import React, { createContext, useContext } from "react";
import useTimeTracking from "../../hooks/TimeTracking/useTimeTracking";

const TimeTrackingContext = createContext<ReturnType<typeof useTimeTracking> | null>(null);

export const TimeTrackingProvider = ({ children }: { children: React.ReactNode }) => {
  const tracking = useTimeTracking();

  return (
    <TimeTrackingContext.Provider value={tracking}>
      {children}
    </TimeTrackingContext.Provider>
  );
};

export const useTracking = () => {
  const context = useContext(TimeTrackingContext);
  if (!context) {
    throw new Error("useTracking must be used within TimeTrackingProvider");
  }
  return context;
};